const toggleEstateTypeContent = () => {
    const estateTypeRadios = document.querySelectorAll('input[name="estate_type"]');
    const content1 = document.querySelector('[data-content1]'); // マンション・アパート
    const content2 = document.querySelector('[data-content2]'); // 戸建て
    const content3 = document.querySelector('[data-content3]'); // 土地

    if (!estateTypeRadios.length || !content1 || !content2 || !content3) return;

    const updateDisplay = (selectedValue) => {
        // 全て非表示にする
        content1.style.display = 'none';
        content2.style.display = 'none';
        content3.style.display = 'none';

        // 選択された値に応じて表示
        if (selectedValue === '1' || selectedValue === '2') {
            // マンション(1) または アパート(2)
            content1.style.display = 'grid';
        } else if (selectedValue === '3') {
            // 戸建て(3)
            content2.style.display = 'grid';
        } else if (selectedValue === '4') {
            // 土地(4)
            content3.style.display = 'grid';
        }
    };

    // 各ラジオボタンにイベントリスナーを追加
    estateTypeRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            updateDisplay(e.target.value);
        });
    });

    // 初期表示（既に選択されている場合）
    const checkedRadio = document.querySelector('input[name="estate_type"]:checked');
    if (checkedRadio) {
        updateDisplay(checkedRadio.value);
    }
};

const main = () => {
    if (document.querySelector('#page-assessment') == null) return;

    toggleEstateTypeContent();
};

export default main;
